/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./header.scss";
import "./mobile.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import ViLanguage from "../../languages/vi";

// const LanguageCollect = ViLanguage;

class HeaderView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: {},
      // isLogin: getUserInfo() ? true : false,
      // planningType: [],
      // isShowUserInfoModal: false,
      // infoAcount: null,
    };
  }

  // getUserAccountDetail() {
  //   this.props.showLoading(true);
  //   acountAction
  //     .GetUserAccountDetail()
  //     .then((res) => {
  //       this.setState({ infoAcount: res && res.content ? res.content : null });
  //       this.props.showLoading(false);
  //     })
  //     .catch((err) => {
  //       this.props.showLoading(false);
  //       ShowNotification(
  //         viVN.Errors[err && err.errorType],
  //         NotificationMessageType.Error
  //       );
  //     });
  // }

  // getAllPlanningType() {
  //   this.props.showLoading(true);
  //   this.props
  //     .getAllPlanningType()
  //     .then((res) => {
  //       this.setState({
  //         planningType:
  //           res && res.content && res.content && res.content.length > 0
  //             ? res.content
  //             : [],
  //       });
  //       this.props.showLoading(false);
  //     })
  //     .catch((err) => {
  //       this.props.showLoading(false);
  //       ShowNotification(
  //         viVN.Errors[err && err.errorType],
  //         NotificationMessageType.Error
  //       );
  //     });
  // }

  // onLogout() {
  //   removeCookies(TokenKey.token);
  //   window.location.replace(DomainUserSide);
  // }

  // //--- User info modal
  // handleOpenUserInfoModal = () => {
  //   this.getUserAccountDetail();
  //   this.setState({
  //     isShowUserInfoModal: true,
  //   });
  // };

  // handleCloseUserInfoModal = () => {
  //   this.setState({
  //     isShowUserInfoModal: false,
  //   });
  // };

  render() {
    // const PATHNAME = this.props.match.path;
    // const isLogin = this.state.isLogin;

    // const renderInfoAcc = () => {
    //   if (this.props.getUser.content) {
    //     return (
    //       <div className="col-md-6">
    //         <div className="header-nav d-flex align-items-stretch justify-content-end">
    //           <div className="nav-item administrator">
    //             <ul className="mg-r-10">
    //               <li>
    //                 <a href="#">
    //                   <span>
    //                     <svg
    //                       width="14"
    //                       height="14"
    //                       viewBox="0 0 14 14"
    //                       fill="none"
    //                       xmlns="http://www.w3.org/2000/svg"
    //                     >
    //                       <g clipPath="url(#clip0)">
    //                         <path
    //                           d="M6.98923 6.74384C7.91571 6.74384 8.71797 6.41155 9.37347 5.75594C10.029 5.10044 10.3613 4.2984 10.3613 3.37181C10.3613 2.44555 10.029 1.6434 9.37337 0.987682C8.71776 0.332289 7.9156 0 6.98923 0C6.06264 0 5.26059 0.332289 4.60509 0.987789C3.94958 1.64329 3.61719 2.44544 3.61719 3.37181C3.61719 4.2984 3.94958 5.10055 4.60519 5.75605C5.2608 6.41144 6.06296 6.74384 6.98923 6.74384Z"
    //                           fill="#838383"
    //                         />
    //                         <path
    //                           d="M12.8004 10.7654C12.7815 10.4926 12.7433 10.1951 12.687 9.88083C12.6301 9.56424 12.557 9.26496 12.4694 8.99142C12.3789 8.70869 12.2559 8.42948 12.1038 8.16192C11.9459 7.88421 11.7605 7.64239 11.5524 7.4434C11.3348 7.23523 11.0685 7.06785 10.7604 6.94577C10.4534 6.82433 10.1132 6.7628 9.74933 6.7628C9.60641 6.7628 9.4682 6.82144 9.20128 6.99522C9.037 7.10235 8.84485 7.22626 8.63037 7.36329C8.44698 7.48015 8.19853 7.58963 7.89166 7.68875C7.59227 7.78563 7.28828 7.83476 6.98825 7.83476C6.68822 7.83476 6.38434 7.78563 6.08463 7.68875C5.77808 7.58973 5.52963 7.48025 5.34645 7.3634C5.134 7.22764 4.94174 7.10374 4.77501 6.99512C4.50841 6.82133 4.37009 6.7627 4.22717 6.7627C3.86316 6.7627 3.52307 6.82433 3.2162 6.94588C2.90837 7.06775 2.64188 7.23512 2.42409 7.44351C2.21613 7.64261 2.03059 7.88432 1.87294 8.16192C1.72095 8.42948 1.5979 8.70858 1.50732 8.99152C1.41985 9.26507 1.34668 9.56424 1.28986 9.88083C1.23357 10.1946 1.19533 10.4923 1.17642 10.7658C1.15784 11.0336 1.14844 11.3117 1.14844 11.5925C1.14844 12.3233 1.38075 12.9149 1.83887 13.3512C2.29132 13.7818 2.89 14.0002 3.61803 14.0002H10.3591C11.0871 14.0002 11.6856 13.7819 12.1382 13.3512C12.5964 12.9152 12.8287 12.3235 12.8287 11.5924C12.8286 11.3103 12.8191 11.032 12.8004 10.7654Z"
    //                           fill="#838383"
    //                         />
    //                       </g>
    //                       <defs>
    //                         <clipPath id="clip0">
    //                           <rect width="14" height="14" fill="white" />
    //                         </clipPath>
    //                       </defs>
    //                     </svg>
    //                     {this.props.getUser.content.company.name}
    //                   </span>
    //                 </a>
    //                 <div className="sub-menu">
    //                   <a href="#">Trang quản trị</a>
    //                   <a href="#">Đăng xuất</a>
    //                 </div>
    //               </li>
    //             </ul>
    //             <a href="#">
    //               <span>
    //                 <svg
    //                   xmlns="http://www.w3.org/2000/svg"
    //                   width="16"
    //                   height="16"
    //                   fill="currentColor"
    //                   class="bi bi-bell-fill"
    //                   viewBox="0 0 16 16"
    //                 >
    //                   <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z" />
    //                 </svg>
    //               </span>
    //             </a>
    //           </div>
    //         </div>
    //       </div>
    //     );
    //   } else {
    //     return null;
    //   }
    // };

    return (
      <header>
        <div className="container header-top-user">
          <div className="row">
            <div className="col-md-6">
              <div className="logo d-flex">
                <a href="/">
                  <img alt="" src={require("../../assets/images/logo.png")} />
                </a>
                <span className="text-header">
                  DỊCH VỤ CÔNG VỀ&nbsp;
                  <br />
                  THẨM DUYỆT THIẾT KẾ, NGHIỆM THU VỀ PHÒNG CHÁY VÀ CHỮA CHÁY
                </span>
              </div>
            </div>
            {/* {renderInfoAcc()} */}
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  // getUser: state.getUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // getUserDetail: getUserService.getUserDetail,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HeaderView);
